import { Component, ViewContainerRef } from '@angular/core';
/*
import { BASE_URL, API_VERSION } from './base.url';
import { SocketConnection } from './theme/services/sdk/sockets/socket.connections'
import {SocketDriver} from "./theme/services/sdk/sockets/socket.driver";
import {SDKModels} from "./theme/services/sdk/services/custom/SDKModels";
import {LoopBackAuth} from "./theme/services/sdk/services/core/auth.service";
import {InternalStorage} from "./theme/services/sdk/storage/storage.swaps";
import {JSONSearchParams} from "./theme/services/sdk/services/core/search.params";*/
import * as $ from 'jquery';

import { GlobalState } from './global.state';
import { BaImageLoaderService, BaThemePreloader, BaThemeSpinner } from './theme/services';
import { BASE_URL, API_VERSION } from './base_url';
import { LoopBackConfig } from './theme/services/sdk/index';
import { BaThemeConfig } from './theme/theme.config';
import { layoutPaths } from './theme/theme.constants';

/*
 * App Component
 * Top Level Component
 */
@Component({
  selector: 'app',
  styleUrls: ['./app.component.scss'],
  template: `
    <main [class.menu-collapsed]="isMenuCollapsed" baThemeRun>
      <div class="additional-bg"></div>
      <router-outlet></router-outlet>
    </main>
  `
})
export class App {

  isMenuCollapsed: boolean = false;

  constructor(private _state: GlobalState,
              private _imageLoader: BaImageLoaderService,
              private _spinner: BaThemeSpinner,
              private viewContainerRef: ViewContainerRef,
              private themeConfig: BaThemeConfig) {

    themeConfig.config();

    LoopBackConfig.setBaseURL(BASE_URL);
    LoopBackConfig.setApiVersion(API_VERSION);

    this._loadImages();

    this._state.subscribe('menu.isCollapsed', (isCollapsed) => {
      this.isMenuCollapsed = isCollapsed;
    });
  }

  public ngAfterViewInit(): void {
    // hide spinner once all loaders are completed
    BaThemePreloader.load().then((values) => {
      this._spinner.hide();
    });
  }

  private _loadImages(): void {
    // register some loaders
    BaThemePreloader.registerLoader(this._imageLoader.load('assets/img/sky-bg.jpg'));
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts